// Two-way computed for date range selectors for preserving context when switching user management tabs
/**
 *
 * @param {string} key key to the { from: string; to: string; } object that stores the data search range within the component
 * @returns
 */
export const makeDateRangeComputed = (key) => {
  let lastValue

  return {
    get() {
      const selectedDateIndex = this.dateRangeList.findIndex(date => date.value.from === this[key].from && date.value.to === this[key].to)
      if (selectedDateIndex === -1) {
        if (lastValue) {
          // We assume that the user has started entering a custom range
          // In order not to startle them by suddenly switching the select to Today we return the last value
          return lastValue
        }

        lastValue = this.dateRangeList[0]
        return lastValue
      }

      lastValue = this.dateRangeList[selectedDateIndex]
      return lastValue
    },
    set(value) {
      this[key].from = value.from
      this[key].to = value.to
    },
  }
}
